import Panel from "components/panels/panel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { Message } from "components/Atoms/Message";
import { useLoaderData } from "react-router";

export const GDPR = () => {
  const viewModel = useLoaderData<server.viewmodel.GdprFrontModel>();

  const gdprExplainerLines = viewModel.gdprExplainer.split("\n\r");

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn gap="bigger">
      <div style={{ overflow: "hidden" }} className="radius-big panel-bg-color">
        <Message type="info" className="radius-big">
          {gdprExplainerLines.map((line, index) => <p key={index}>{line}</p>)}
        </Message>
      </div>

      <Panel panelClassName="s1_panel">
        <article
          dangerouslySetInnerHTML={{
            __html: "<h1>" + viewModel.pageTitle + "</h1><br />" + viewModel.gdprContent
          }}
        />
      </Panel>

    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}